<template>
  <div class="page-wrapper">
    <a-card class="card-wrapper">
      <!-- 搜索条件表单 -->
      <a-form :layout="'inline'" @submit.prevent="onSearch" class="search-form">
        <a-form-item label="用户ID">
          <a-input v-model:value="filters.userId" style="width: 120px" placeholder="用户ID" />
        </a-form-item>
        <a-form-item label="用户名">
          <a-input v-model:value="filters.username" placeholder="用户名" />
        </a-form-item>
        <a-form-item label="兑换码">
          <a-input v-model:value="filters.convertCode" placeholder="兑换码" />
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker
              v-model:value="filters.dateRange"
              style="width: 320px"
              :allowClear="true"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onSearch">搜索</a-button>
          <a-button style="margin-left: 8px;" @click="onReset">重置</a-button>
        </a-form-item>
      </a-form>

      <!-- 分页表格 -->
      <a-table
          :columns="columns"
          :dataSource="dataList"
          :loading="loading"
          :pagination="pagination"
          @change="onTableChange"
          :rowKey="record => record.convertCode"
          bordered
          :scroll="{ x: 'max-content', y: tableScrollY }"
          class="data-table"
      >
        <template #convertTime="{ text }">
          {{ text || '-' }}
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import moment from 'moment'

export default {
  name: 'ConvertDetail',
  data() {
    return {
      comboId: null,
      filters: {
        userId: null,
        username: '',
        convertCode: '',
        startDate: null,
        dateRange: [], // 替代 startDate 和 endDate
      },
      dataList: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
      },
      tableScrollY: 400, // 表格纵向滚动高度，根据需要调整
      columns: [
        { title: '用户ID', dataIndex: 'userId', key: 'userId', width: 100 },
        { title: '用户名', dataIndex: 'userName', key: 'userName', width: 150 },
        { title: '兑换码', dataIndex: 'convertCode', key: 'convertCode', width: 150 },
        { title: '兑换时间', dataIndex: 'convertTime', key: 'convertTime', width: 180 },
        { title: '兑换短剧名称', dataIndex: 'convertVideoName', key: 'convertVideoName', width: 250 },
      ],
    }
  },
  created() {
    this.comboId = this.$route.query.comboId
    if (!this.comboId) {
      this.$message.error('缺少comboId参数')
      return
    }
    this.fetchData()
    this.updateTableHeight()
    window.addEventListener('resize', this.updateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableHeight)
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('YYYY-MM-DD') : undefined
    },
    fetchData(page = 1, pageSize = this.pagination.pageSize) {
      this.loading = true
      const [startDate, endDate] = this.filters.dateRange || []
      const params = {
        comboId: this.comboId,
        userId: this.filters.userId || undefined,
        username: this.filters.username || undefined,
        convertCode: this.filters.convertCode || undefined,
        startDate: this.formatDate(startDate),
        endDate: this.formatDate(endDate),
        pageNum: page,
        pageSize,
      }
      request
          .get('/video/convertcombo/getConvertDetailPage', { params })
          .then((res) => {
            if (res && res.success) {
              this.dataList = res.data.records || []
              this.pagination.total = res.data.total || 0
              this.pagination.current = page
              this.pagination.pageSize = pageSize
            } else {
              this.$message.error(res.message || '获取数据失败')
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
    onSearch() {
      this.fetchData(1)
    },
    onReset() {
      this.filters = {
        userId: null,
        username: '',
        convertCode: '',
        dateRange: [],
      }
      this.fetchData(1)
    },
    onTableChange(pagination) {
      this.fetchData(pagination.current, pagination.pageSize)
    },
    updateTableHeight() {
      // 动态计算表格高度，减去搜索栏和卡片内边距
      const headerHeight = 72 // 搜索表单大致高度
      const cardPadding = 32
      const windowHeight = window.innerHeight
      this.tableScrollY = windowHeight - headerHeight - cardPadding - 100 // 留出分页及页脚空间
    },
  },
}
</script>

<style scoped>
.page-wrapper {
  height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
}

.card-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-form {
  margin-bottom: 16px;
  flex-shrink: 0;
  width: 100%;
}

.data-table {
  flex: 1;
  overflow: auto;
}
</style>
